const state = {
  accountId: null as string | null,
};

const getCurrentAccountId = (): string | null => state.accountId;
const setCurrentAccountId = (accountId: string | null): void => {
  state.accountId = accountId;
};

export { getCurrentAccountId, setCurrentAccountId };
